import { render, staticRenderFns } from "./mIndex.vue?vue&type=template&id=2121e1a4&scoped=true"
import script from "./mIndex.vue?vue&type=script&lang=js"
export * from "./mIndex.vue?vue&type=script&lang=js"
import style0 from "./mIndex.vue?vue&type=style&index=0&id=2121e1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__ejs@3.1.10_loda_cce3uyf2imv72g6btugowonk4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121e1a4",
  null
  
)

export default component.exports